
import Event = createjs.Event;

export class Poker2ShopEvent extends Event {
    public static CHANGE_CATEGORY: string = "changeCategory";
    public static CHANGE_SUB_CATEGORY: string = "changeSubCategory";
    public static UPDATE_START_PACKAGES: string = "updateStartPackages";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
